import React from "react";
import {LoadMenuDetailsEpic} from '../../actions/website.actions';
import {SaveMenuEpic, DeleteMenuEpic} from '../../actions/website.actions';
import {connect} from 'react-redux'
import { withRouter } from 'react-router-dom'
import {push} from 'react-router-redux';
import CircularProgress from 'material-ui/CircularProgress';
import ErrorBlock from '../../components/ErrorBlock';
import FlatButton from 'material-ui/FlatButton';
import ResourceList from '../../components/ResourceList';
import RaisedButton from 'material-ui/RaisedButton';
import WebsiteContentField from '../../components/WebsiteContentField';

export class MenuDetails extends React.Component {
  constructor(props){
    super(props);
    this.state = { menu: {}};
  }
  componentDidMount() {
    this.props.loadMenuDetails(this.props.websiteId, this.props.menuId);
  }

  componentWillReceiveProps(newProps){
    this.setState(newProps);
  }

  viewItem = (rowData) => {
    this.props.navigateToGroupMenuItem(this.props.match.params.websiteId, this.props.match.params.menuId, this.props.menu.menu_groups[0].id, rowData.id);
  }

  onFieldChange = (propertyName, value) => {
    let menu = {
      ...this.state.menu,
      [propertyName]: value
    };
    this.setState({menu});
  }

  getColumns = () => {
    return [
    {name: 'menu_item_name', label: 'Item Name ', render: (rowData) => <span>{ rowData.menu_item_name ? rowData.menu_item_name : '<no name>' }</span>},
    {name: 'menu_item_price', label: 'Price ', render: (rowData) => <span>{ rowData.menu_item_price ? rowData.menu_item_price : 'FREE' }</span>},
      {name: 'details', width: 68, label: 'Action', render: (rowData) => <span><FlatButton onClick={this.viewItem.bind(this,rowData)} label='Edit' primary={true}/></span>}
    ]
  }

  onSave = () => {
    const saveData = {
      menu_name: this.state.menu.menu_name
    };

    this.props.save(this.props.websiteId, this.state.menu.id, saveData);
  }

  onDelete = () => {
    if (window.confirm('Are you sure you want to delete this menu?')) {
      this.props.delete(this.props.websiteId, this.props.menuId);
    }
  }

  menuDetails() {
    return (
      <div>
        <div style={{display: 'flex', flexDirection:'row', alignContent:'center', alignItems:'center'}}>
          <div><h1>Menu Details</h1></div>
          <div style={{flex:1}}>&nbsp;</div>
          <div>
            <FlatButton label={"Delete"} secondary onClick={()=>this.onDelete()}/>
            <RaisedButton onClick={this.onSave} label="Save" primary={true}/>
          </div>
        </div>
        <WebsiteContentField type="text" value={this.state.menu.menu_name} onChange={(value)=> this.onFieldChange('menu_name', value)} label="Name" />
        <WebsiteContentField type="text" value={this.state.menu.currency_symbol} label="Currency Symbol" />
        <WebsiteContentField type="text" value={this.state.menu.language} label="Language" />
        <WebsiteContentField type="text" value={this.state.menu.menu_note} label="Note" />
        <WebsiteContentField type="text" value={this.state.menu.menu_description} label="Description" />
        <br /><br />
        <div style={{display: 'flex', flexDirection:'row', alignContent:'center', alignItems:'center'}}>
          <div><h1>Items</h1></div>
          <div style={{flex:1}}>&nbsp;</div>
          <div>
            <RaisedButton label={"+ New Item"} primary={true} onClick={()=>this.props.navigateToNewMenuItem(this.props.websiteId, this.state.menu.id, this.state.menu.menu_groups[0].id)}/>
          </div>
        </div>
        <ResourceList showHeader={false} columns={this.getColumns()} data={this.props.menu.menu_groups[0].menu_items} showCheckboxes={false}/>
      </div>
      );
  }

  render() {
    if (this.props.loading) {
      return  <div style={{textAlign: 'center'}}><CircularProgress/></div>;
    }

    if (this.props.error) {
      return <ErrorBlock errorText="Unable to retrieve menu details at this time."/>
    }

    if (!this.props.menu){
      return <span></span>;
    }

    return (
     <div>
       <div>
         <div>
            {this.menuDetails()}
          </div>
         </div>
      </div>);
  }
}

let mapStateToProps = ({websiteEndpoint, referenceData},{match}) => ({
  loading: websiteEndpoint.fetchInProgress,
  error: websiteEndpoint.fetchError,
  menuId: match.params.menuId,
  websiteId: match.params.websiteId,
  menu: websiteEndpoint.menu
})

let mapDispatchToProps = (dispatch) => ({
  loadMenuDetails : (websiteId, menuId) => dispatch(LoadMenuDetailsEpic(websiteId, menuId)),
  navigateToGroup: (websiteId, menuId, groupId) => dispatch(push(`/websites/${websiteId}/menu/${menuId}/group/${groupId}`)),
  navigateToGroupMenuItem: (websiteId, menuId, groupId, menuItemId) => dispatch(push(`/websites/${websiteId}/menu/${menuId}/group/${groupId}/item/${menuItemId}`)),
  navigateToNewMenuItem: (websiteId, menuId, groupId) => dispatch(push(`/websites/${websiteId}/menu/${menuId}/group/${groupId}/items/add`)),
  save : (websiteId, menuId, data) => dispatch(SaveMenuEpic(websiteId, menuId, data)),
  delete : (websiteId, menuId, data) => dispatch(DeleteMenuEpic(websiteId, menuId))
});

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(MenuDetails));



// WEBPACK FOOTER //
// ./src/containers/Menu/MenuDetails.js